import { CriticalIcon, Paragraph } from '@buffer-mono/popcorn'

import styles from './TemplateManager.module.css'

import type { JSX } from 'react'

export function FormError({ message }: { message: string }): JSX.Element {
  return (
    <Paragraph
      size="sm"
      color="critical"
      className={styles.formError}
      icon={<CriticalIcon size="small" color="critical" />}
    >
      {message}
    </Paragraph>
  )
}
